import React, { useState } from 'react'
import { Spin, Tag, Popover, Tooltip, message } from 'antd'
import ProcessingTime from '../../shared/ProcessingTime'
import { retryJobOddBatch } from '../../../services/api/3dApi'
import moment from 'moment'
import { Link } from 'react-router-dom'

const OddBatchTable = (props) => {
    const { loading, reload, listOddBatch, onChangeStatus } = props
    const [hovering, setHovering] = useState(false)

    const handleHovering = (isHover) => {
        setHovering(isHover)
    }

    const renderBatchOdd = (arr = []) => {
        if (Array.isArray(arr) && arr.length > 0) {
            return arr.map((item, i) => (
                <Link
                    to={{
                        pathname: "/batches",
                        search: `?name=${arr}`
                    }}
                    target='_blank'
                >
                    {i === arr.length - 1 ? `${item}` : `${item}, `}
                </Link>
            ))
        }

        return '-'
    }

    const renderStatus = (status = '', error = '', processing_at = '') => {
        if (!status) return '-'

        switch (status) {
            case 'pending':
                return <Tag color="#efb700">{status}</Tag>
            case 'processing':
                return !processing_at ?
                    <Tag color="#499ff7">{status}</Tag> :
                    <Tooltip
                        placement='topLeft'
                        title={<ProcessingTime processingAt={processing_at} hovering={hovering} />}
                        onMouseEnter={() => handleHovering(true)}
                        onMouseLeave={() => handleHovering(false)}
                    >
                        <Tag color="#499ff7">{status}</Tag>
                    </Tooltip>
            case 'error':
                return <Popover content={error || 'Something error!'} placement='topRight'>
                    <Tag className='cursor-pointer' color="#e94528">{status}</Tag>
                </Popover>
            case 'retry':
                return <Tag color="#f0b800">{status}</Tag>
            default:
                return <Tag color="#51ac4d">{status}</Tag>
        }
    }

    const retryJob = async (id) => {
        try {
            const { data: res } = await retryJobOddBatch(id)
            const { success, error } = { ...res }

            if (!success) return message.error(error)

            message.success('Retry job thành công!')
            onChangeStatus(id, 'retry')

        } catch (error) {
            message.error(error.message)
        }
    }

    return (
        <div className='OddBatchTable'>
            <Spin spinning={loading} tip='Đang tải...'>
                <table className='table table-borderless table-striped'>
                    <thead className='thead-light'>
                        <tr>
                            <th className="name-odd-batch">Tên lô lẻ</th>
                            <th className="name-combine-batch">Tên lô ghép</th>
                            <th className="created">Ngày tạo</th>
                            <th className='status text-center'>Trạng thái</th>
                            <th className='action'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            listOddBatch.length > 0 ? (
                                listOddBatch.map(item => {
                                    const { _id, input, output, created_at, status, error = '', processing_at = '' } = Object.assign({}, item)

                                    return (
                                        <tr key={item._id}>
                                            <td className="name-odd-batch">{renderBatchOdd(input)}</td>
                                            <td className="name-combine-batch">{renderBatchOdd(output)}</td>
                                            <td className="created">{moment(created_at).format("HH:mm DD/MM/YYYY")}</td>
                                            <td className='status text-center'>{renderStatus(status, error, processing_at)}</td>
                                            <td className='action'>
                                                {
                                                    status === 'error' &&
                                                    <div className='IconRetry' onClick={() => retryJob(_id)}>
                                                        <Tooltip title='Retry' placement='bottom'>
                                                            <i className='fa fa-share-square-o' />
                                                        </Tooltip>
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                                )
                            ) : (
                                <tr>
                                    <td colSpan={5}>No data</td>
                                </tr>
                            )
                        }
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default OddBatchTable